import { render, staticRenderFns } from "./NewsCenter.vue?vue&type=template&id=da580846&scoped=true&"
import script from "./NewsCenter.vue?vue&type=script&lang=js&"
export * from "./NewsCenter.vue?vue&type=script&lang=js&"
import style0 from "./NewsCenter.vue?vue&type=style&index=0&id=da580846&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da580846",
  null
  
)

export default component.exports